import { useEffect, useState } from "react"
import { FaRegStar, FaStar, FaStarHalfAlt } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { API_CONFIG, API_HEADERS } from "../../../network/config/ApiConfig";
import { AUDIO_ROOM_API_PATH, USER_API_PATH } from "../../../network/config/apiPaths";
import axios from "axios";

function PatnerReviews() {
    const location = useLocation();
    const date = new Date();
    const dateFormate = date.toDateString().substring(4, 15)
    const navigate = useNavigate();
    console.log("date", date);
    const roomid = location.state.roomId;
    const [reviews, setReviews] = useState([
    ])
    // { patnerName: "Chinni", votsCount: 35, feedback: "Sweet voice chinni", rating: 5, time: dateFormate, albumRoom: location.state.name },
    // { patnerName: "Rajesh", votsCount: 20, feedback: "I'm big fan of your voice", rating: 5, time: dateFormate, albumRoom: location.state.name },
    // { patnerName: "Sravya", votsCount: 10, feedback: "Nice", rating: 5, time: dateFormate, albumRoom: location.state.name },

    // const pollData = [
    //     { patnerName: 'Chinni', percentage: 90 },
    //     { patnerName: 'Rajesh', percentage: 85 },
    //     { patnerName: 'Sravya', percentage: 30 },
    // ];

    useEffect(() => {
        participantReviews();
    }, [])

    console.log("review", reviews)

    const participenReview = (participentName, partId) => {
        navigate("/participentReview", { state: { name: participentName, participant_id: partId, room_id: location.state.roomId } })
    }

    const participantReviews = async () => {
        let requestBody = {
            room_id: roomid,
        }
        const data = await axios.post(
            API_CONFIG.API_HOST + AUDIO_ROOM_API_PATH.AUDIO_ROOM_PARTICIPANTS, requestBody,
            {
                headers: API_HEADERS,
            }
        );
        console.log("users", data.data.result.data)
        if (data.data.result !== null) {
            setReviews(data.data.result.data)


        }
    };

function Rating( rating ) {
    console.log("rating starts",rating)
  return (
    <div style={{ display: "flex", gap: "4px" }}>
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i}>
          {rating >= i ? (
            <FaStar color="gold" size={24} />
          ) : rating >= i - 0.5 ? (
            <FaStarHalfAlt color="gold" size={24} />
          ) : (
            <FaRegStar color="gold" size={24} />
          )}
        </span>
      ))}
    </div>
  );
}
    return (
        <>
            <div className="container-fluid dashboard">
                <div className="row d-flex flex-row">
                    {
                        reviews.map((obj, i) => {
                            return (
                                <>
                                {obj.role_id==4?<div className="col-4 mt-3 " onClick={() => participenReview(obj.name, obj.id)} key={obj.id}>
                                        <div className="hover-box">
                                            <div className="p-3">
                                                <h6 className="" style={{ color: "green", marginLeft: 10 }}>{obj.name}</h6>
                                                <p className="" style={{ marginLeft: 10 }}>{location.state.name}</p>
                                                <div style={{ marginLeft: 10 }}>

                                                    <span style={{ fontWeight: 600 }}>Vots {obj.votsCount}</span>
                                                    <span style={{ marginLeft: 10, color: "#B2BEB5" }}>{dateFormate}</span>
                                                    <span style={{ marginLeft: 5, color: "#B2BEB5" }}>{date.getHours()}:{date.getMinutes()}</span>

                                                    <p>{obj.all_comments}</p>
                                                    <span>

                                                        {/* {[...Array(Number(obj.rating))].map((_, i) => (
                                                            <FaStar key={i} color="gold" />
                                                        ))} */}
                                                        {
                                                            Rating(obj.rating)
                                                        }
                                                        

                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>:""}
                                    
                                </>
                            )
                        })
                    }
                </div>
                <div className="row mt-5">
                    <div className="col-5">
                        <div style={{ width: '100%', height: 400 }}>
                            <h3 style={{ textAlign: 'center' }}>Poll Results</h3>
                            <ResponsiveContainer>
                                <BarChart data={reviews} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip />
                                    <Bar dataKey="rating" fill="#4caf50" barSize={30} />
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default PatnerReviews